"use strict"
exports.__esModule = true;
exports.GamepadIconConfig = {
  name: 'GamepadIcon',
  height: 512,
  width: 640,
  svgPath: 'M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z',
  yOffset: 0,
  xOffset: 0,
};
exports.GamepadIcon = require('../createIcon').createIcon(exports.GamepadIconConfig);
exports["default"] = exports.GamepadIcon;